
import { getSVGIcon } from "~/functions"
import { Operator } from "~/types/operator"

export const brava: Operator = {
	id: 'brava',
	name: 'Brava',
	role: 'Attacker',
	org: 'COT',
	squad: 'VIPERSTRIKE',
	ratings: {
		health: 1,
		speed: 3,
		difficulty: 3
	},
	meta: {
		gender: 'f',
		country: 'br',
		season: 'Y8S1',
		height: 170,
		weight: 71,
		price: {
			renown: 15000,
			r6credits: 360
		}
	},
	bio: {
		real_name: 'Nayara Cardoso',
		birthplace: 'Curitiba, Brazil'
	},
	svg: {
		contents: '<switch><foreignObject width="1" height="1" x="0" y="0" requiredExtensions="http://ns.adobe.com/AdobeIllustrator/10.0/"></foreignObject><g><path d="M45.001 45.004h260v260h-260z" style="opacity:.4"></path><path d="M73.001 73.004h204v44l43-9-43 73v34l7 4-7 4v54h-49l9 44-75-44h-34l-4 7-4-7h-47z" style="fill:#45abf3"></path><path d="m113.001 30.004 88 62c6 4 11.488 2.071 13-4l6-23 31 78 7-10 57-22-63 88c-5 7 2 13 6 14l22 6-74 29 25 65-83-59c-9.3-6.6-16.6-2.9-18 2l-6 22-31-77-7 9-59 24 64-89c4-5.5 3-11.5-6-14l-22-6 75-29zm54 107 40 30-30 40-40-30z" style="fill-rule:evenodd;clip-rule:evenodd"></path><path d="m124.001 44.004 71 50c11.741 8.313 20.398 5.68 23-3l3-11 26 68-17 24-24-61-5 17-62-44zm83 123 17.4 12.8-8.7 12.1c-2.082 2.878-.7 6.1 2.3 7.1l17 5-40 15 15 39-56-40c-4.03-2.908-9.556-4.072-11 1l-4 15-30-78 68 51z" style="fill:#fff"></path><path d="m140.001 101.004 6 16-7 12-29 11 17 5-44 61-42 17 54-75c9-11 2-21-16-24z" style="fill:#fff"></path></g></switch>',
		attributes: {
			xmlns: 'http://www.w3.org/2000/svg',
			space: 'preserve',
			viewBox: '0 0 350 350',
			class: 'r6operators r6operators-brava'
		}
	},
	toSVG: function(userAttr){return getSVGIcon(this, userAttr)}
}
